const getCurrentDateFormat = (currentDate = new Date()) => {
    const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    const monthName = currentDate.toLocaleDateString('es-MX', { month: 'long' }).toLowerCase();
    const year = currentDate.getFullYear();
    const currentMonthText = `${firstDay.getDate()} al ${lastDay.getDate()} de ${monthName} del ${year}`;
    return {
        currentMonthText,
        firstDay,
        lastDay,
        monthName,
        year
    };
};
export default getCurrentDateFormat;
